import type { HubGame } from '@/types';

/**
 * Operator fact sheets (PDF). Add a public path when a title's sheet is ready,
 * keyed by catalog game id or symbol.
 */
const GAME_DATA_PDF: Record<string, string> = {};

export function gameDataPdfUrl(game: HubGame): string | null {
  const byId = GAME_DATA_PDF[game.id];
  if (byId) return byId;
  const symbol = game.details?.symbol;
  if (symbol && GAME_DATA_PDF[symbol]) return GAME_DATA_PDF[symbol];
  return null;
}
